// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 167 ? "80289b8c" : chunkId) + "." + {"167":"8a757cc5cee39829","171":"d524a2c9115f9903","753":"e3bea01958f3ea2c"}[chunkId] + ".js";
};